/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserIdDto } from './UserIdDto';
import {
    UserIdDtoFromJSON,
    UserIdDtoFromJSONTyped,
    UserIdDtoToJSON,
} from './UserIdDto';

/**
 * 
 * @export
 * @interface DeleteUserDto
 */
export interface DeleteUserDto {
    /**
     * 
     * @type {UserIdDto}
     * @memberof DeleteUserDto
     */
    userId: UserIdDto;
}

/**
 * Check if a given object implements the DeleteUserDto interface.
 */
export function instanceOfDeleteUserDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;

    return isInstance;
}

export function DeleteUserDtoFromJSON(json: any): DeleteUserDto {
    return DeleteUserDtoFromJSONTyped(json, false);
}

export function DeleteUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': UserIdDtoFromJSON(json['userId']),
    };
}

export function DeleteUserDtoToJSON(value?: DeleteUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': UserIdDtoToJSON(value.userId),
    };
}

